export const getVariantIcon = (variant: any) => {
  switch (variant) {
    case 'info': {
      return 'info';
    }
    case 'warning': {
      return 'warning';
    }
    default: {
      return null;
    }
  }
};
